const initFestivalNavigationScrollControls = () => {
    document.querySelectorAll('[data-festival-navigation-frame]').forEach((frame) => {
        const viewport = frame.querySelector('[data-festival-primary-nav-viewport]');
        const primary = frame.querySelector('[data-festival-primary-nav]');
        const previous = frame.querySelector('[data-festival-nav-scroll-previous]');
        const next = frame.querySelector('[data-festival-nav-scroll-next]');
        if (!viewport || !primary || !previous || !next) return;

        // Livewire can preserve the frame while morphing its controls. Tear down
        // bindings that reference the old children before wiring the current DOM.
        frame._festivalNavigationAbortController?.abort();
        frame._festivalNavigationResizeObserver?.disconnect();

        const controller = new AbortController();
        frame._festivalNavigationAbortController = controller;
        frame.dataset.scrollControlsReady = 'true';

        const maxScroll = () => Math.max(0, viewport.scrollWidth - viewport.clientWidth);

        const render = () => {
            const max = maxScroll();
            const left = viewport.scrollLeft;
            previous.hidden = left <= 2;
            previous.disabled = left <= 2;
            next.hidden = false;
            next.disabled = max <= 2 || left >= max - 2;
            frame.classList.toggle('has-scroll-overflow', max > 2);
        };

        const move = (direction) => {
            const amount = Math.max(180, Math.round(viewport.clientWidth * 0.72));
            const target = Math.min(Math.max(0, viewport.scrollLeft + (direction * amount)), maxScroll());
            viewport.scrollLeft = target;
            render();
        };

        // Delegate one click path from the preserved frame so replacement arrow
        // elements keep working after Livewire navigation. Using click (rather
        // than pointerup plus per-button click handlers) also avoids moving twice
        // for a normal tap and preserves keyboard activation of native buttons.
        frame.addEventListener('click', (event) => {
            const button = event.target.closest('[data-festival-nav-scroll-previous], [data-festival-nav-scroll-next]');
            if (!button || !frame.contains(button)) return;

            event.preventDefault();
            event.stopPropagation();
            const direction = button.hasAttribute('data-festival-nav-scroll-previous') ? -1 : 1;
            move(direction);
        }, { signal: controller.signal });
        viewport.addEventListener('scroll', render, { passive: true, signal: controller.signal });
        window.addEventListener('resize', render, { passive: true, signal: controller.signal });

        if ('ResizeObserver' in window) {
            const observer = new ResizeObserver(render);
            observer.observe(viewport);
            observer.observe(primary);
            frame._festivalNavigationResizeObserver = observer;
        }

        primary.style.transform = '';
        render();
    });
};

document.addEventListener('DOMContentLoaded', initFestivalNavigationScrollControls);
document.addEventListener('livewire:navigated', initFestivalNavigationScrollControls);
